export default class AccDetails {
    constructor() {
        this.items = []
        this.seasonalEventTickets = []

        this.listDetails = this.listDetails.bind(this)
        this.listSeasonalEventTicketsDetails = this.listSeasonalEventTicketsDetails.bind(this)
        this.init = this.init.bind(this)

        this.listDetails()
        this.listSeasonalEventTicketsDetails()

        this.init()
        this.seasonalEventTicketsInit()
    }

    init() {
        if (this.items.length === 0) return false

        if (!Element.prototype.matches) {
            Element.prototype.matches =
                Element.prototype.msMatchesSelector ||
                Element.prototype.webkitMatchesSelector;
        }

        if (!Element.prototype.closest) {
            Element.prototype.closest = function (s) {
                var el = this;

                do {
                    if (Element.prototype.matches.call(el, s)) return el;
                    el = el.parentElement || el.parentNode;
                } while (el !== null && el.nodeType === 1);
                return null;
            };
        }

        Array.prototype.slice.call(this.items).forEach(item => {
            item.el.addEventListener('click', () => {
                item.handleClick()
            })
            item.handleClick()
        })

        const accDetailContent = Array.prototype.slice.call(document.querySelectorAll('.acc-detail-content'))
        accDetailContent.forEach(content => {
            let expandable = content.getElementsByClassName('js-expand')[0] || null
            if (expandable) {
                let link = content.getElementsByClassName('js-view-more')[0] || null
                let closeLink = content.getElementsByClassName('js-view-less')[0] || null
                if (link) {
                    link.onclick = () => {
                        link.style.display = 'none'
                        closeLink.style.display = 'block'
                        expandable.classList.add('show')
                        return false
                    }
                    closeLink.onclick = () => {
                        link.style.display = 'block'
                        closeLink.style.display = 'none'
                        expandable.classList.remove('show')
                        return false
                    }
                }
            }
        })

    }

    seasonalEventTicketsInit() {
        if (this.seasonalEventTickets.length === 0) return false

        Array.prototype.slice.call(this.seasonalEventTickets).forEach(ticketItem => {
            ticketItem.el.addEventListener('click', () => {
                ticketItem.handleSeasonalEventTicketClick()
            })
            ticketItem.handleSeasonalEventTicketClick()
        })
    }

    listDetails() {
        const accDetails = Array.prototype.slice.call(document.querySelectorAll('.acc-detail'))

        accDetails.forEach(item => {
            const detail = new Detail(item)
            this.items.push(detail)
        })
    }

    listSeasonalEventTicketsDetails() {
        const accDetails = Array.prototype.slice.call(document.querySelectorAll('.js-acc-ticket-detail'))

        accDetails.forEach(item => {
            const detail = new Detail(item)
            this.seasonalEventTickets.push(detail)
        })
    }
}

class Detail {
    constructor(el) {
        this.el = el
        this.isOpen = false
        this.isSeasonalEventsSectionOpen = true

        this.handleClick = this.handleClick.bind(this)
    }

    handleClick() {
        this.isOpen = this.isOpen ? false : true
        switch (this.isOpen) {
            case true:
                this.el.classList.remove('hide-details')
                this.el.classList.add('show-details')
                break
            case false:
                this.el.classList.add('hide-details')
                this.el.classList.remove('show-details')
            default:
                break
        }
    }

    handleSeasonalEventTicketClick() {
        var container = this.el.closest(".season-ticket-accordion");
        switch (this.isSeasonalEventsSectionOpen) {
            case true:
                container.classList.remove('hide-season-ticket-details')
                container.classList.add('show-season-ticket-details')
                this.isSeasonalEventsSectionOpen = false;
                break
            case false:
                container.classList.add('hide-season-ticket-details')
                container.classList.remove('show-season-ticket-details')
                this.isSeasonalEventsSectionOpen = true;
            default:
                break
        }
    }
}